<template>
  <div class="number-input-container mb-3">
    <label class="mb-4">
      <question-display :question="question" customClass="customHeader"></question-display>
    </label>

    <div class="mt-4">
      <label>Number of nights in the USA (including U.S. territories)</label>
      <div class="form-inline ">
        <input
          type="number"
          class="form-control w-100"
          placeholder="Enter value"
          min="0"
          max="365"
          v-model.number="inputA"
          @input="updateTotal"
        />
      </div>
      <small v-if="errorA" class="text-danger">{{ errorA }}</small>
    </div>

    <div class="mb-4">
      <label>Number of nights outside the USA</label>
      <div class="form-inline">
        <input
          type="number"
          class="form-control w-100"
          placeholder="Enter value"
          min="0"
          max="365"
          v-model.number="inputB"
          @input="updateTotal"
        />
      </div>
      <small v-if=" errorB" class="text-danger">{{ errorB }}</small>
    </div>

    <div class="mb-4">
      <label>Total Nights on This Trip</label>
      <div class="form-inline">
        <input
          type="number"
          class="form-control w-100 dis-number"
          :value="totalNights"
          readonly
        />
      </div>
    </div>
  </div>
</template>

<script>
import surveyService from '@/services/surveyService';
import QuestionDisplay from "../../utils/QuestionDisplay.vue";

export default {
  components: {
    QuestionDisplay
  },
  props: {
    question: Object,
    required: Boolean,
    showValidation: Boolean
  },
  data() {
    return {
      inputA: 0,
      inputB: 0,
      errorA: '',
      errorB: ''
    };
  },
  computed: {
    totalNights() {
      return this.inputA + this.inputB;
    },
    // Computed property to determine overall validity
    isValid() {
      return !this.errorA && !this.errorB && this.inputA >= 0 && this.inputB >= 0;
    }
  },
  methods: {
    updateTotal() {
      this.validateInputs();

      const answer = {
        usaNights: this.inputA || 0,
        outsideNights: this.inputB || 0,
        totalNights: this.totalNights
      };

      surveyService.setAnswer(this.question.id, answer);
      this.$emit('input', answer);
    },
    validateInputs() {
      this.errorA = '';
      this.errorB = '';

      let hasError = false;

      // Ensure inputs are numbers and handle negative values
      if (isNaN(this.inputA) || this.inputA === null || this.inputA === '') {
        this.inputA = 0;
      }
      if (this.inputA < 0) {
        this.inputA = 0;
      }
      
      if (isNaN(this.inputB) || this.inputB === null || this.inputB === '') {
        this.inputB = 0;
      }
      if (this.inputB < 0) {
        this.inputB = 0;
      }

      // Validate max values
      if (this.inputA > 365) {
        this.errorA = 'Maximum allowed is 365 days.';
        hasError = true;
      }

      if (this.inputB > 365) {
        this.errorB = 'Maximum allowed is 365 days.';
        hasError = true;
      }

      // Emit validation status (true = has error, false = no error)
      this.$emit('validation-status', hasError);
    }
  },
  created() {
    // Load saved data when component is created
    const saved = surveyService.getAnswer(this.question.id);
    if (saved) {
      this.inputA = saved.usaNights || 0;
      this.inputB = saved.outsideNights || 0;
    }
  },
  mounted() {
    // Emit initial validation status after mount
    this.$nextTick(() => {
      this.validateInputs();
    });
  },
  // Watch for changes in inputA and inputB to trigger validation immediately
  watch: {
    inputA() {
      this.updateTotal();
    },
    inputB() {
      this.updateTotal();
    },
    // Watch for question prop changes (when navigating back to this page)
    question: {
      handler() {
        const saved = surveyService.getAnswer(this.question.id);
        if (saved) {
          this.inputA = saved.usaNights || 0;
          this.inputB = saved.outsideNights || 0;
        }
        this.$nextTick(() => {
          this.validateInputs();
        });
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.dis-number {
  background-color: #eaeaea;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.w-100 {
  width: 100% !important;
}
</style>